import React, { FunctionComponent, MouseEvent } from "react";
import { useIntl } from "react-intl";
import "./style.scss";

interface Props {
  onClick: (event: MouseEvent) => void;
}

const SelectionPagination: FunctionComponent<Props> = ({ onClick }) => {
  const intl = useIntl();

  return (
    <div className="SelectionPagination">
      <span className="SelectionPagination-button" onClick={onClick}>
        {intl.formatMessage({ id: "kustom_SelectionPagination_seeMore" })}&nbsp;+
      </span>
    </div>
  );
};

export default SelectionPagination;
